// ReusableGrid.js
import React, { useCallback, useMemo, useRef, useState } from 'react';
import { AgGridReact } from 'ag-grid-react';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';
import "./component.css";
import * as XLSX from 'xlsx';
// import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
// import { faFileExcel } from '@fortawesome/free-regular-svg-icons';
// import { faEye } from '@fortawesome/free-solid-svg-icons';
// import { AllModules } from "@ag-grid-enterprise/all-modules";
// import { ExcelExportModule } from '@ag-grid-enterprise/excel-export';

function RenderGrid({ columnDefs, rowData, selectCheckBox, agGridRef, handleCheckboxChange, searchText, onGridReady, handleCellValueChanged }) {
  

  
  function exportJsonToXLSX(data, sheetName, excelFileName) {
    try {
        var workBook = XLSX.utils.book_new();
        var workSheet = XLSX.utils.json_to_sheet(data, {
            skipHeader: false,
        });
        XLSX.utils.book_append_sheet(workBook, workSheet, sheetName);
        XLSX.writeFile(workBook, excelFileName);
        return true;
    }
    catch
    {
        return false;
    }
}

function exportToExcel() {
    let fileNameChange = "Report.xlsx";
    let sheetName = "sheet";

    let excelExportData = [];

    for (let i = 0; i < rowData.length; i++) {
        let data = {};
        for (let key in rowData[i]) {
            for (let j = 0; j < columnDefs.length; j++) {
                if (key === columnDefs[j]["field"]) {
                    data[columnDefs[j]["headerName"]] = rowData[i][key]
                }
            }
        }

        excelExportData.push(data);
    };

    exportJsonToXLSX(excelExportData, sheetName, fileNameChange);

}

  // const gridOptions = {
  //   modules: AllModules,
  // };

  return (
    <>
    <div className='row'>
    <div className='col-md-11'>

    </div>
    <div className='col-md-1'>
    <a onClick={exportToExcel}>
    <i class='fas fa-file-excel' style={{fontSize:'30px',color:'green'}}></i>
</a>
      </div></div>
    <div className="ag-theme-alpine" style={{ height: '385px', width: '100%' }}>
      <AgGridReact
        columnDefs={columnDefs}
        rowData={rowData}
        animateRows={true}
        ref={agGridRef}
        rowSelection={selectCheckBox}
        pagination={true}
        paginationPageSize={10}
        //groupSelectsChildren={true}
        suppressAggAtRootLevel={true}
        onRowSelected={handleCheckboxChange}
        // suppressRowClickSelection={false}
        quickFilterText={searchText}
        enableRangeSelection={true}
        enableRangeCopy={true}
        onGridReady={onGridReady}
        onCellValueChanged={handleCellValueChanged}
        // gridOptions={gridOptions}
      />
    </div>
    </>
  );
}

export default RenderGrid;
